import includes from 'lodash/includes';
import map from 'lodash/map';

import postalCodeRegex from '../../constants/postalCodeRegex';
import US_STATES from '../../constants/usStates';

export function castLienholderValueBasedOnOwnershipStatus({
  passSchema,
  ownershipStatus,
  inputName,
  isRequired = false,
}: {
  passSchema: any;
  ownershipStatus?: 'owned' | 'financed' | 'leased';
  inputName: string;
  isRequired?: boolean;
}) {
  if (includes(['leased', 'financed'], ownershipStatus)) {
    let schema;
    switch (inputName) {
      case 'lienholder_name':
      case 'address_line1':
        schema = passSchema;
        break;
      case 'address_line2':
        schema = passSchema
          .nullable()
          .transform((value: string) => (value === '' ? null : value));
        break;
      case 'address_city':
        schema = passSchema.matches(
          /^([^0-9]*)$/,
          `The city name should not contain digits.`
        );
        break;
      case 'address_region':
        schema = passSchema.oneOf(
          map(US_STATES, '[0]'),
          'Please select a state to continue.'
        );
        break;
      case 'address_postal':
        schema = passSchema.test(
          'address_postal',
          'Invalid zip',
          (value?: string) => {
            if (!value) {
              return true;
            }
            return postalCodeRegex.test(value);
          }
        );
        break;
      default:
        schema = passSchema;
    }
    return isRequired ? schema.required('This field is required') : schema;
  }
  return passSchema.transform(() => null);
}
